export default () => ({
    open: false,
    hidden: false,
    contrast: false,
    fallbackScrollLocked: false,
    wasLenisStopped: false,
    lastScrollY: 0,
    scrollFrame: null,
    scrollThreshold: 12,
    hideAfterScrollY: 120,
    handleScroll: null,

    init() {
        this.lastScrollY = this.getScrollY();
        this.handleScroll = () => this.scheduleScrollSync();

        this.syncScrollLock();
        this.syncHeaderVisibility();
        this.syncHeaderContrast();

        window.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener('resize', this.handleScroll, { passive: true });

        this.$watch('open', () => this.syncScrollLock());
        this.$watch('open', () => this.syncHeaderVisibility());
        this.$watch('open', () => this.syncHeaderContrast());
        this.$watch('$store.app.isMobile', () => {
            this.syncScrollLock();
            this.syncHeaderVisibility();
            this.syncHeaderContrast();
        });
    },

    destroy() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleScroll);

        if (this.scrollFrame) {
            cancelAnimationFrame(this.scrollFrame);
            this.scrollFrame = null;
        }

        this.unlockScroll();
    },

    toggle() {
        this.open = !this.open;
    },

    syncScrollLock() {
        if (this.open && this.$store.app.isMobile) {
            this.lockScroll();
            return;
        }

        this.unlockScroll();
    },

    lockScroll() {
        if (window.pageScrollLock) {
            window.pageScrollLock.lock('header');
            return;
        }

        if (this.fallbackScrollLocked) {
            return;
        }

        const lenis = window.lenis;

        this.wasLenisStopped = Boolean(lenis?.isStopped);
        this.fallbackScrollLocked = true;
        document.documentElement.classList.add('dialog-noscroll');
        lenis?.stop?.();
    },

    unlockScroll() {
        if (window.pageScrollLock) {
            window.pageScrollLock.unlock('header');
            return;
        }

        if (!this.fallbackScrollLocked) {
            return;
        }

        this.fallbackScrollLocked = false;
        document.documentElement.classList.remove('dialog-noscroll');

        if (!this.wasLenisStopped) {
            window.lenis?.start?.();
        }
    },

    scheduleScrollSync() {
        if (this.scrollFrame) {
            return;
        }

        this.scrollFrame = requestAnimationFrame(() => {
            this.scrollFrame = null;
            this.syncHeaderVisibility();
            this.syncHeaderContrast();
        });
    },

    syncHeaderVisibility() {
        const currentScrollY = this.getScrollY();

        if (this.$store.app.isMobile || this.open || currentScrollY <= 0) {
            this.hidden = false;
            this.lastScrollY = currentScrollY;
            return;
        }

        const scrollDelta = currentScrollY - this.lastScrollY;

        if (Math.abs(scrollDelta) < this.scrollThreshold) {
            return;
        }

        this.hidden = scrollDelta > 0 && currentScrollY > this.hideAfterScrollY;
        this.lastScrollY = currentScrollY;
    },

    syncHeaderContrast() {
        if (this.open) {
            this.contrast = false;
            return;
        }

        const header = this.$el.querySelector('.header');
        const triggers = document.querySelectorAll('.header-contrast-trigger');

        if (!header || !triggers.length) {
            this.contrast = false;
            return;
        }

        const headerRect = header.getBoundingClientRect();
        const probeY = Math.max(headerRect.top, 0) + (headerRect.height / 2);

        this.contrast = Array.from(triggers).some((trigger) => {
            const rect = trigger.getBoundingClientRect();

            return rect.top <= probeY && rect.bottom >= probeY;
        });
    },

    getScrollY() {
        return window.pageYOffset || document.documentElement.scrollTop || 0;
    },
});
